module.exports = __webpack_public_path__ + "static/assets/9ed309caca7d7bbed239fd5493c9619b.png";